import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {joiResolver} from "@hookform/resolvers/joi";
import {Link, useNavigate} from "react-router-dom";

import styles from './ForgotPasswordStep1.module.scss';
import logo from '../../constants/images/logo.svg';
import ReturnToLoginPage from "../../components/UI/ReturnToLoginPage/ReturnToLoginPage";
import {forgotPasswordStep1Validator} from "../../validators/forgotPasswordStep1.validator";
import {MAIN_ROUTES} from "../../routing/main_routes";
import {endPoints} from "../../configs/urls";
import {axiosService} from "../../services/axios.service";

const ForgotPasswordStep1 = () => {
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: {errors, isValid},
    reset,
    setValue
  } = useForm({
    resolver: joiResolver(forgotPasswordStep1Validator),
    mode: 'all',
  });


  const onSubmit = async (data) => {
    try {
      await axiosService.post(endPoints.passwordRecovery.sendLink, {
        ...data,
        password_recovery_url: process.env.REACT_APP_URL + MAIN_ROUTES.FORGOT_PASSWORD_STEP_3
      });

      navigate(MAIN_ROUTES.FORGOT_PASSWORD_STEP_2, {state: {email: data.email}});
    } catch (e) {
      console.error(error);
      setError(JSON.stringify(error?.response?.data || error?.message));
    }
  }

  return (
    <div className={styles.forgotPasswordStep1_wrapper}>
      <div className={styles.forgotPasswordStep1_wrapper_forgotPasswordStep1}>
        <div className={styles.forgotPasswordStep1_wrapper_forgotPasswordStep1_title}>
          <img src={logo} alt="quality cleaning logo"/>

          <div>
            <h1 className={styles.title}>Забули пароль?</h1>
            <p className={styles.paragraph}>Не хвилюйтеся, ми надішлемо вам інструкції зі скидання.</p>
          </div>
        </div>

        <form
          onSubmit={handleSubmit(onSubmit)}
          className={styles.forgotPasswordStep1_wrapper_forgotPasswordStep1_form}
        >
          <div className={styles.forgotPasswordStep1_wrapper_forgotPasswordStep1_form_block}>
            <label>
              Email
              <input
                {...register('email')}
                className={styles.input}
                type="email"
                placeholder={'Введіть ваш email'}
              />
            </label>
            {errors.email && <span className={styles.error}> {errors.email.message} </span>}
          </div>

          {/*<Link to={MAIN_ROUTES.FORGOT_PASSWORD_STEP_2} style={{width: '100%'}}>*/}
            <button type={"submit"} disabled={!isValid}
                    className={styles.forgotPasswordStep1_wrapper_forgotPasswordStep1_button}>Скинути Пароль
            </button>
          {/*</Link>*/}
        </form>

        <ReturnToLoginPage/>
      </div>
    </div>
  );
};

export default ForgotPasswordStep1;
